<template>
  <!-- 分享 -->
  <a-modal
    v-model="isVisible"
    :title="$t('docs_share_title')"
    :footer="null"
    centered
    v-if="record"
  >
    <div class="docs-share">
      <a-input-search
        size="large"
        @search="
          () => {
            copyContent(`#copyShareURL`);
          }
        "
        :value="getShareURL(record.id)"
        readOnly
        id="DocsShareURL"
      >
        <a-button
          type="primary"
          :data-clipboard-text="getShareURL(record.id)"
          id="copyShareURL"
          data-clipboard-action="copy"
          size="large"
          slot="enterButton"
        >
          {{ $t('com_btn_copy') }}
        </a-button>
      </a-input-search>
      <div class="docs-share-btn">
        <a-button type="default" size="large" @click="show(false)" class="g-btn-icon">
          {{ $t('com_btn_close') }}
        </a-button>
      </div>
    </div>
  </a-modal>
</template>
<script>
import { copyContent } from '@/libs/utils';
export default {
  data() {
    return {
      copyContent,
      isVisible: false,
      record: null,
    };
  },
  watch: {
    visible(val) {
      this.isVisible = val;
    },
  },
  created() {
    this.isVisible = this.visible;
  },
  methods: {
    // show
    show(status, record) {
      this.record = record;
      this.isVisible = status;
    },

    // 获取当前URL协议 + 域名 + 路径
    getShareURL() {
      return (
        window.location.protocol +
        '//' +
        window.location.host +
        '/manage/docs/detail/' +
        this.record?.id
      );
    },
  },
};
</script>
<style lang="less" scoped>
.docs-share {
  padding: 24px 0 0;
  .docs-share-btn {
    padding: 24px 0 0 0;
    display: flex;
    justify-content: flex-end;
  }
}
</style>
